/**
 * Component Types
 * Defines available component types for the chat UI
 * 
 * Use these constants when:
 * - Creating UI descriptors in messageTransformer
 * - Looking up components from the catalog registry
 * - Registering new components in chat-components
 */

// ============================================================================
// Chat Message Components
// Core message display components
// ============================================================================

export const COMPONENT_TYPES = {
    /** User message bubble */
    USER_MESSAGE: 'UserMessage',
    /** Assistant response with markdown support */
    ASSISTANT_MESSAGE: 'AssistantMessage',
    /** Loading/thinking step indicator */
    STEP_INDICATOR: 'StepIndicator',
    /** Error message display */
    ERROR_MESSAGE: 'ErrorMessage',
    /** Suggested prompt chips */
    CHAT_SUGGESTIONS: 'ChatSuggestions'
};

/**
 * Get component type from message role
 * @param {string} role - Message role ('user', 'assistant', 'system')
 * @returns {string} Component type
 */
export const getComponentTypeFromRole = (role) => {
    switch (role) {
        case 'user':
            return COMPONENT_TYPES.USER_MESSAGE;
        case 'assistant':
            return COMPONENT_TYPES.ASSISTANT_MESSAGE;
        default:
            return COMPONENT_TYPES.ASSISTANT_MESSAGE;
    }
};

export default COMPONENT_TYPES;
